var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.modalShown,
          expression: "modalShown"
        },
        {
          name: "drag",
          rawName: "v-drag",
          value: { handle: "#modal-moving" },
          expression: "{handle:'#modal-moving'}"
        }
      ],
      staticClass: "modal",
      staticStyle: { position: "fixed" },
      attrs: { id: "add-user-modal" }
    },
    [
      _c("div", { staticClass: "modal-main" }, [
        _c(
          "div",
          { staticClass: "title-area", attrs: { id: "modal-moving" } },
          [
            _vm.isNew && !_vm.isDel
              ? _c("h2", [_vm._v("新規ユーザーの追加")])
              : _vm._e(),
            _vm._v(" "),
            !_vm.isNew && !_vm.isDel
              ? _c("h2", [_vm._v("ユーザーの編集")])
              : _vm._e(),
            _vm._v(" "),
            !_vm.isNew && _vm.isDel
              ? _c("h2", [_vm._v("ユーザーの削除")])
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "data-area" }, [
          !_vm.isDel
            ? _c("div", { staticClass: "error_message" }, [
                _vm._v(_vm._s(_vm.errorMessage.text))
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("ul", { class: [_vm.isDel ? "del_st" : ""] }, [
            _c("li", [
              _c("span", { staticClass: "label" }, [
                _vm._v("メールアドレス/ログインID")
              ]),
              _vm._v(" "),
              _vm.isNew && !_vm.isDel
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.mail,
                        expression: "mail"
                      }
                    ],
                    staticClass: "user-input",
                    attrs: {
                      type: "text",
                      placeholder: "メールアドレス/ログインID"
                    },
                    domProps: { value: _vm.mail },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.mail = $event.target.value
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.isNew && !_vm.isDel
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.editObj.email,
                        expression: "editObj.email"
                      }
                    ],
                    staticClass: "user-input",
                    attrs: { type: "text" },
                    domProps: { value: _vm.editObj.email },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.editObj, "email", $event.target.value)
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.isNew && _vm.isDel
                ? _c("span", [_vm._v(_vm._s(_vm.userObj.email))])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("li", [
              _c("span", { staticClass: "label" }, [_vm._v("ユーザーコード")]),
              _vm._v(" "),
              _vm.isNew && !_vm.isDel
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.userCode,
                        expression: "userCode"
                      }
                    ],
                    staticClass: "user-input",
                    attrs: { type: "text", placeholder: "ユーザーコード" },
                    domProps: { value: _vm.userCode },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.userCode = $event.target.value
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.isNew && !_vm.isDel
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.editObj.userCode,
                        expression: "editObj.userCode"
                      }
                    ],
                    staticClass: "user-input",
                    attrs: { type: "text" },
                    domProps: { value: _vm.editObj.userCode },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.editObj, "userCode", $event.target.value)
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.isNew && _vm.isDel
                ? _c("span", [_vm._v(_vm._s(_vm.userObj.userCode))])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("li", [
              _c("span", { staticClass: "label" }, [_vm._v("名前")]),
              _vm._v(" "),
              _vm.isNew && !_vm.isDel
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.userLastName,
                        expression: "userLastName"
                      }
                    ],
                    staticClass: "user-input",
                    attrs: { type: "text", placeholder: "姓" },
                    domProps: { value: _vm.userLastName },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.userLastName = $event.target.value
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.isNew && !_vm.isDel
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.editObj.userLastName,
                        expression: "editObj.userLastName"
                      }
                    ],
                    staticClass: "user-input",
                    attrs: { type: "text" },
                    domProps: { value: _vm.editObj.userLastName },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.editObj,
                          "userLastName",
                          $event.target.value
                        )
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.isNew && _vm.isDel
                ? _c("span", [_vm._v(_vm._s(_vm.userObj.userLastName))])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("li", [
              _c("span", { staticClass: "label" }),
              _vm._v(" "),
              _vm.isNew && !_vm.isDel
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.userFirstName,
                        expression: "userFirstName"
                      }
                    ],
                    staticClass: "user-input",
                    attrs: { type: "text", placeholder: "名" },
                    domProps: { value: _vm.userFirstName },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.userFirstName = $event.target.value
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.isNew && !_vm.isDel
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.editObj.userFirstName,
                        expression: "editObj.userFirstName"
                      }
                    ],
                    staticClass: "user-input",
                    attrs: { type: "text" },
                    domProps: { value: _vm.editObj.userFirstName },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.editObj,
                          "userFirstName",
                          $event.target.value
                        )
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.isNew && _vm.isDel
                ? _c("span", [_vm._v(_vm._s(_vm.userObj.userFirstName))])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("li", [
              _c("span", { staticClass: "label" }, [_vm._v("名前（カナ）")]),
              _vm._v(" "),
              _vm.isNew && !_vm.isDel
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.userLastNameKana,
                        expression: "userLastNameKana"
                      }
                    ],
                    staticClass: "user-input",
                    attrs: { type: "text", placeholder: "姓（カナ）" },
                    domProps: { value: _vm.userLastNameKana },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.userLastNameKana = $event.target.value
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.isNew && !_vm.isDel
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.editObj.userLastNameKana,
                        expression: "editObj.userLastNameKana"
                      }
                    ],
                    staticClass: "user-input",
                    attrs: { type: "text" },
                    domProps: { value: _vm.editObj.userLastNameKana },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.editObj,
                          "userLastNameKana",
                          $event.target.value
                        )
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.isNew && _vm.isDel
                ? _c("span", [_vm._v(_vm._s(_vm.userObj.userLastNameKana))])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("li", [
              _c("span", { staticClass: "label" }),
              _vm._v(" "),
              _vm.isNew && !_vm.isDel
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.userFirstNameKana,
                        expression: "userFirstNameKana"
                      }
                    ],
                    staticClass: "user-input",
                    attrs: { type: "text", placeholder: "名（カナ）" },
                    domProps: { value: _vm.userFirstNameKana },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.userFirstNameKana = $event.target.value
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.isNew && !_vm.isDel
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.editObj.userFirstNameKana,
                        expression: "editObj.userFirstNameKana"
                      }
                    ],
                    staticClass: "user-input",
                    attrs: { type: "text" },
                    domProps: { value: _vm.editObj.userFirstNameKana },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.editObj,
                          "userFirstNameKana",
                          $event.target.value
                        )
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.isNew && _vm.isDel
                ? _c("span", [_vm._v(_vm._s(_vm.userObj.userFirstNameKana))])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("li", [
              _c("span", { staticClass: "label" }, [_vm._v("ユーザータイプ")]),
              _vm._v(" "),
              _vm.isNew && !_vm.isDel
                ? _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.userType,
                          expression: "userType"
                        }
                      ],
                      attrs: { placeholder: "ユーザータイプ" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.userType = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    _vm._l(_vm.selectUserTypeList, function(type, index) {
                      return _c(
                        "option",
                        { key: index, domProps: { value: type.code } },
                        [_vm._v(_vm._s(type.label))]
                      )
                    })
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isNew && !_vm.isDel
                ? _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.editObj.userType,
                          expression: "editObj.userType"
                        }
                      ],
                      attrs: { disabled: _vm.isDisable },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.editObj,
                            "userType",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    _vm._l(_vm.selectUserTypeList, function(type, index) {
                      return _c(
                        "option",
                        { key: index, domProps: { value: type.code } },
                        [_vm._v(_vm._s(type.label))]
                      )
                    })
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isNew &&
              _vm.isDel &&
              _vm.userObj &&
              Object.keys(_vm.userObj).length > 0
                ? _c("span", [_vm._v(_vm._s(_vm.userTypeByDel.label))])
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _vm.isNew && !_vm.isDel
            ? _c("div", [_vm._v("※登録すると本人に登録用メールが送られます。")])
            : _vm._e()
        ]),
        _vm._v(" "),
        !_vm.isDel
          ? _c("div", [
              _vm.validateErrorMessages &&
              Object.keys(_vm.validateErrorMessages).length > 0
                ? _c("p", { staticClass: "error_message" }, [
                    _vm._v(_vm._s(_vm.validateErrorMessages["userEmail"]))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.validateErrorMessages &&
              Object.keys(_vm.validateErrorMessages).length > 0
                ? _c("p", { staticClass: "error_message" }, [
                    _vm._v(_vm._s(_vm.validateErrorMessages["userCode"]))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.validateErrorMessages &&
              Object.keys(_vm.validateErrorMessages).length > 0
                ? _c("p", { staticClass: "error_message" }, [
                    _vm._v(_vm._s(_vm.validateErrorMessages["lastName"]))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.validateErrorMessages &&
              Object.keys(_vm.validateErrorMessages).length > 0
                ? _c("p", { staticClass: "error_message" }, [
                    _vm._v(_vm._s(_vm.validateErrorMessages["firstName"]))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.validateErrorMessages &&
              Object.keys(_vm.validateErrorMessages).length > 0
                ? _c("p", { staticClass: "error_message" }, [
                    _vm._v(_vm._s(_vm.validateErrorMessages["lastNameKana"]))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.validateErrorMessages &&
              Object.keys(_vm.validateErrorMessages).length > 0
                ? _c("p", { staticClass: "error_message" }, [
                    _vm._v(_vm._s(_vm.validateErrorMessages["firstNameKana"]))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.validateErrorMessages &&
              Object.keys(_vm.validateErrorMessages).length > 0
                ? _c("p", { staticClass: "error_message" }, [
                    _vm._v(_vm._s(_vm.validateErrorMessages["userType"]))
                  ])
                : _vm._e()
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "button-area" }, [
          _vm.isNew && !_vm.isDel
            ? _c(
                "button",
                {
                  staticClass: "main_btn",
                  attrs: { type: "button" },
                  on: { click: _vm.addUser }
                },
                [_vm._v("登録")]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isNew && !_vm.isDel
            ? _c(
                "button",
                {
                  staticClass: "main_btn",
                  attrs: { type: "button" },
                  on: { click: _vm.updateUser }
                },
                [_vm._v("変更")]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isNew && _vm.isDel
            ? _c(
                "button",
                {
                  staticClass: "main_btn",
                  attrs: { type: "button" },
                  on: { click: _vm.delUser }
                },
                [_vm._v("削除")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "main_btn",
              attrs: { type: "button" },
              on: { click: _vm.onCancel }
            },
            [_vm._v("キャンセル")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("dd-loading-modal", { ref: "loadingModalRef" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-50ac8084", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50ac8084","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/components/common/UserModal.vue
// module id = null
// module chunks = 